import { useMemo } from 'react';
import cn from 'classnames';
import { Image } from '../../../common/components/Image';
import { Link } from 'react-router';
import { SocialNetworksFormData } from './contracts';
import { useSocialNetworksQuery } from '@data/socialNetworks/useSocialNetworksQuery';
import { Loader } from '@ui/common/components/Loader/Loader';

export type SocialNetworksProps = SocialNetworksFormData & {
  className?: string;
};

export function SocialNetworks(props: SocialNetworksProps) {
  const { data, isLoading, error } = useSocialNetworksQuery();

  const socialNetworks = useMemo(() => {
    if (data) {
      const newSocialNetworks: SocialNetworksFormData = {};

      data.forEach((socialNetwork) => {
        if (socialNetwork.networkType === 'facebook') {
          newSocialNetworks.facebook = socialNetwork.url;
        } else if (socialNetwork.networkType === 'twitter') {
          newSocialNetworks.twitter = socialNetwork.url;
        } else if (socialNetwork.networkType === 'instagram') {
          newSocialNetworks.instagram = socialNetwork.url;
        } else if (socialNetwork.networkType === 'youtube') {
          newSocialNetworks.youtube = socialNetwork.url;
        } else if (socialNetwork.networkType === 'tiktok') {
          newSocialNetworks.tiktok = socialNetwork.url;
        } else if (socialNetwork.networkType === 'threads') {
          newSocialNetworks.threads = socialNetwork.url;
        } else if (socialNetwork.networkType === 'whatsapp') {
          newSocialNetworks.whatsapp = socialNetwork.url;
        } else if (socialNetwork.networkType === 'bluesky') {
          newSocialNetworks.bluesky = socialNetwork.url;
        }
      });

      return newSocialNetworks;
    }

    return null;
  }, [data]);

  if (isLoading) {
    return <Loader />;
  }

  if (error || !socialNetworks) {
    return null;
  }

  return (
    <ul className={cn('social-networks', props.className)}>
      {socialNetworks.facebook && (
        <li>
          <Link to={socialNetworks.facebook} target="_blank">
            <Image src="/facebook-icon.png" alt={'Facebook logo'} />
          </Link>
        </li>
      )}
      {socialNetworks.twitter && (
        <li>
          <Link to={socialNetworks.twitter} target="_blank">
            <Image src="/x-icon.png" alt={'Twitter logo'} />
          </Link>
        </li>
      )}
      {socialNetworks.instagram && (
        <li>
          <Link to={socialNetworks.instagram} target="_blank">
            <Image src="/instagram-icon.png" alt={'Instagram logo'} />
          </Link>
        </li>
      )}
      {socialNetworks.youtube && (
        <li>
          <Link to={socialNetworks.youtube} target="_blank">
            <Image src="/youtube-icon.png" alt={'Youtube logo'} />
          </Link>
        </li>
      )}
      {socialNetworks.tiktok && (
        <li>
          <Link to={socialNetworks.tiktok} target="_blank">
            <Image src="/tiktok-icon.png" alt={'TikTok logo'} />
          </Link>
        </li>
      )}
      {socialNetworks.threads && (
        <li>
          <Link to={socialNetworks.threads} target="_blank">
            <Image src="/threads-icon.png" alt={'Threads logo'} />
          </Link>
        </li>
      )}
      {socialNetworks.whatsapp && (
        <li>
          <Link to={socialNetworks.whatsapp} target="_blank">
            <Image src="/whatsapp-icon.png" alt={'WhatsApp logo'} />
          </Link>
        </li>
      )}
      {socialNetworks.bluesky && (
        <li>
          <Link to={socialNetworks.bluesky} target="_blank">
            <Image src="/bluesky-icon.png" alt={'Bluesky logo'} />
          </Link>
        </li>
      )}
    </ul>
  );
}
